import * as ActionTypes from './ActionTypes';

export const NotifReducer = (state = {
    notifs: [],
    isLoading: false,
     err: null
 }, action) => {
     switch (action.type) {
         case ActionTypes.ADD_NOTIF:
             return { ...state, isLoading: false, err: null, notifs: action.payload };
         case ActionTypes.GET_NOTIF:
             return { ...state, isLoading: false, err: null, notifs: action.payload };   
         default:
             return state;
     }
 }